import React, { useState } from "react";
import config from "lib/fr-config";
import { useLocation, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { getDeviceType } from "lib/deviceInfo";
import { withStore } from "store/storeHandler";
import CommonIconView from "presentational/common/CommonIconView";
import TextButtonView from "presentational/common/TextButtonView";
import Typography from "@material-ui/core/Typography";
import TXT from "presentational/common/multinational/TXT";
import { getEssentialUrl } from "lib/urlQueryParser";

const MAJOR_TXT_COLOR = "rgba(0,0,0,0.6)";
const MINOR_TXT_COLOR = "rgba(0,0,0,0.45)";

const fontCss = config.css.fontThickness;
const commonCss = config.css.commonDevice;

const PADDING_HEIGHT = commonCss.textButton.normalPaddingTop;

const css = {
  infoElement: {
    display: "inline-block",
    paddingRight: 15
  },
  corpInfoTxtWrapper: {
    paddingTop: PADDING_HEIGHT,
    paddingBottom: PADDING_HEIGHT
  },
  corpInfoInvisible: { display: "none" },
  copyrightTxtWrapper: {
    paddingTop: PADDING_HEIGHT,
    paddingBottom: getDeviceType() === "mobile" ? 0 : 30
  }
};

const TitleTypography = withStyles({
  root: {
    display: "inline",
    color: MAJOR_TXT_COLOR,
    fontSize: 12,
    fontWeight: fontCss.medium
  }
})(Typography);
const ValueTypography = withStyles({
  root: {
    display: "inline",
    color: MINOR_TXT_COLOR,
    fontSize: 12,
    fontWeight: fontCss.regular,
    paddingLeft: 5
  }
})(Typography);
const CopyrightTypography = withStyles({
  root: {
    color: MINOR_TXT_COLOR,
    fontSize: 10,
    fontWeight: fontCss.black
  }
})(Typography);
const TermsTypography = withStyles({
  root: {
    color: MAJOR_TXT_COLOR,
    fontSize: 12,
    fontWeight: fontCss.medium,
    paddingRight: 10,
    paddingBottom: 8
  }
})(Typography);

function FooterArea(props) {
  const { viewerLocation } = props;
  const [isCompanyInfoHidden, setIsCompanyInfoHidden] = useState(true);

  const location = useLocation();

  const getInfoElement = (title, value) => {
    return (
      <span style={css.infoElement}>
        <TitleTypography>{title}</TitleTypography>
        {value && <ValueTypography>{value}</ValueTypography>}
      </span>
    );
  };

  const getTermsElement = () => {
    return (
      <div style={{ display: "flex" }}>
        <Link to={getTermsUrl()}>
          <TermsTypography>
            <TXT name="btnFooter_termsOfUse" />
          </TermsTypography>
        </Link>
        <Link to={getPrivacyUrl()}>
          <TermsTypography>
            <TXT name="btnFooter_privacyPolicy" />
          </TermsTypography>
        </Link>
      </div>
    );
  };

  const getCompanyInfoElement = locType => {
    let companyButtonLabel, companyDetailArr;
    if (locType === "kr") {
      companyButtonLabel = "어메이브(주) 사업자 정보";
      companyDetailArr = [
        ["어메이브 주식회사 (AMAIVE Corp.)"],
        ["대표", "김재하"],
        ["사업자등록번호", "226-86-02055"],
        [
          "주소",
          "경기도 수원시 팔달구 효원로249번길 46-15, 5층 11호(인계동, 성운프라자)"
        ],
        ["통신판매업신고번호", "2022-수원팔달-0631호"],
        ["이메일", "help@maunent.com"],
        ["전화번호", "070-4247-1339"]
      ];
    } else {
      companyButtonLabel = "Company Info";
      companyDetailArr = [
        ["AMAIVE Corp."],
        // ["Discover and organize your personal style with Maunent."],
        ["Contact", "help@maunent.com"]
      ];
    }

    return (
      <div>
        <TextButtonView
          fontSize={12}
          paddingSize={"normal"}
          disableLeftMargin
          fontColor={MAJOR_TXT_COLOR}
          onClick={handleCompanyBtnClick}
        >
          {companyButtonLabel}{" "}
          <CommonIconView
            type={isCompanyInfoHidden ? "expandMore" : "expandLess"}
          />
        </TextButtonView>
        <div>
          <div
            style={{
              ...css.corpInfoTxtWrapper,
              ...(isCompanyInfoHidden ? css.corpInfoInvisible : {})
            }}
          >
            {companyDetailArr.map((info, index) => (
              <React.Fragment key={index}>
                {getInfoElement(...info)}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const mainContent = () => {
    return (
      <div>
        {getTermsElement()}
        {viewerLocation === "KR"
          ? getCompanyInfoElement("kr")
          : getCompanyInfoElement("us")}
        <div style={css.copyrightTxtWrapper}>
          <CopyrightTypography>
            © {new Date().getFullYear()} AMAIVE Corp. All right reserved.
          </CopyrightTypography>
        </div>
      </div>
    );
  };

  const getTermsUrl = () => {
    const language = viewerLocation === "KR" ? "ko" : "en";
    return getEssentialUrl({ type: "terms" })(language);
  };

  const getPrivacyUrl = () => {
    const language = viewerLocation === "KR" ? "ko" : "en";
    return getEssentialUrl({ type: "privacy" })(language);
  };

  const handleCompanyBtnClick = () => {
    setIsCompanyInfoHidden(!isCompanyInfoHidden);
  };

  const getFooterArea = () => {
    if (getDeviceType() === "mobile") {
      switch (location.pathname) {
        case getEssentialUrl({ type: "opening" })():
        case getEssentialUrl({ type: "about" })():
        case getEssentialUrl({ type: "membership" })():
          return mainContent();

        default:
          return null;
      }
    } else {
      switch (location.pathname) {
        case getEssentialUrl({ type: "opening" })():
        case getEssentialUrl({ type: "about" })():
        case getEssentialUrl({ type: "membership" })():
          return mainContent();

        default:
          return null;
      }
    }
  };

  return getFooterArea();
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  }
})(FooterArea);
